export const LOGIN = "LOGIN";
export const LOAD_SESSION = "LOAD_SESSION";
export const LOGOUT = "LOGOUT";